module.exports = __webpack_public_path__ + "media/images/game/categories/financni_rezervy_a_investice-239d2acab5b98507f3c4a2cb7253dd4c.png";